import { Carousel, useBreakpoint, Breakpoints } from '@nextgen-web-framework/all';
import MeetOurPeopleItem from './MeetOurPeopleItem';
import type { MeetOurPeopleItemProps, MeetOurPeopleProps } from './types/propsTypes';
import styles from './MeetOurPeople.module.scss';

const MeetOurPeople = (props: MeetOurPeopleProps) => {
  const viewport = useBreakpoint();
  const isMobile = [Breakpoints.SM, Breakpoints.XS].includes(viewport as Breakpoints);
  return (
    <div className={styles['meet-our-people-container']} data-testid={'meet-our-people-test-id'}>
      <h3 className={styles['meet-our-people-title-section']}>{props.displayTitle}</h3>
      <div className={styles['meet-our-people-carousel-section']}>
        <div className={styles['meet-our-people-carousel']}>
          <Carousel
            id={'Meet-Our-People-Carousel'}
            hideButtons={true}
            isTileCarousel={true}
            dotsPaddingTop={isMobile ? 16 : 32}
          >
            {props.meetOurPeopleData.map((item: MeetOurPeopleItemProps) => (
              <MeetOurPeopleItem key={`${item.title}`} {...item} />
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default MeetOurPeople;
export type { MeetOurPeopleProps };
